import styled, { css } from 'styled-components';

export const Container = styled.div`
  min-width: 100%;
  overflow: hidden;
  background: #fff;
`;

export const Title = styled.p`
  margin: 0;
  padding: 20px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  font-weight: bold;
`;

export const OptionWrapper = styled.span`
  display: inline-block;
  margin-left: auto;
`;

export const Option = styled.span`
  cursor: pointer;
  font-size: 12px;
  &:not(:last-child) {
    padding: 0 10px;
    border-right: 1px solid #e3e3e3;
  }
  &:last-child {
    padding-left: 10px;
  }

  ${(props) =>
    props.isSelected &&
    css`
      color: #ee1a21;
    `}
`;

export const Table = styled.table`
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;

  border: 1px solid #f2f2f2;
  & > tbody > tr > th {
    height: 36px;
    font-size: 11px;
    text-align: center;
    background: #fff;
    border-bottom: 1px solid #f2f2f2;
  }
  & > tbody > tr {
    border-bottom: 1px solid rgb(236, 239, 243);
  }
  & > tbody > tr:last-child {
    border-bottom: none;
  }

  & > tbody td {
    height: 38px;
    font-size: 13px;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const SubTableCell = styled.td`
  overflow-x: scroll;
  padding: 0;
  vertical-align: top;
`;
export const TeamCell = styled.div`
  display: flex;
  align-content: center;
  justify-content: flex-start;
  margin-left: 10px;
  line-height: 20px;

  & > div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
    vertical-align: middle;
    margin-left: 10px;
  }
`;

export const SubTable = styled.table`
  margin: 0;
  padding: 0;
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
  background: #f6f6f6;
  border: 1px solid #fff;

  & th {
    font-size: 11px;
    height: 36px;
    border: 1px solid #fff;
  }
  & td {
    font-size: 13px;
    height: 38px;
    border: 1px solid #fff;
  }
`;
